/* Native editorial enquiries. No Shopify contact or marketing subscription side effects. */
(() => {
  function today() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
  function init(root) {
    root.querySelectorAll('[data-enquiry-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const started = Date.now();
      let pending = false, lastSuccess = null;
      const button = form.querySelector('button[type="submit"]');
      const label = button.textContent;
      const summary = form.querySelector('[data-summary]');
      const sendError = form.querySelector('[data-send-error]');
      const controls = Array.from(form.querySelectorAll('input, select, textarea'));
      const date = controls.find((field) => field.name === 'event_date');
      date.min = today();
      function mark(name, message) {
        const error = form.querySelector(`[data-error="${name}"]`);
        if (!error) return;
        error.textContent = message;
        error.hidden = false;
        controls.filter((field) => field.name === name).forEach((field) => {
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', error.id);
        });
      }
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || (lastSuccess !== null && Date.now() - lastSuccess < 30000)) return;
        summary.hidden = true;
        sendError.hidden = true;
        form.querySelectorAll('[data-error]').forEach((error) => { error.hidden = true; });
        controls.forEach((field) => field.removeAttribute('aria-invalid'));
        date.min = today();
        const invalid = controls.filter((field) => {
          const bad = (field.required && !field.value.trim()) || !field.checkValidity();
          if (bad) mark(field.name, field.validationMessage || 'Please complete this field.');
          return bad;
        });
        if (invalid.length) {
          summary.textContent = 'Please check the highlighted fields before sending your enquiry.';
          summary.hidden = false;
          invalid[0].focus();
          return;
        }
        pending = true;
        button.disabled = true;
        button.textContent = 'Sending...';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          if (!form.dataset.url.trim()) throw new Error('Missing webhook URL');
          const body = new URLSearchParams();
          ['name', 'email', 'phone', 'event_date', 'event_city', 'venue', 'colour_palette', 'flowers', 'budget', 'website'].forEach((name) => {
            body.set(name, controls.find((field) => field.name === name).value);
          });
          body.set('event_types', controls.filter((field) => field.name === 'event_types' && (field.type === 'hidden' || field.checked)).map((field) => field.value).join(','));
          body.set('marketing_opt_in', controls.find((field) => field.name === 'marketing_opt_in').checked ? 'yes' : '');
          body.set('form', form.dataset.type);
          body.set('elapsed_ms', String(Date.now() - started));
          const url = new URL(location.href);
          url.search = '';
          body.set('page_url', url.href);
          body.set('submitted_at', new Date().toISOString());
          const response = await fetch(form.dataset.url, { method: 'POST', body, signal: controller.signal });
          const result = await response.json();
          if (response.status !== 200 || result.ok !== true) {
            if (response.status === 400 && Array.isArray(result.fields)) {
              result.fields.forEach((name) => {
                // Only contract field names are used in selectors.
                if (controls.some((field) => field.name === name)) mark(name, 'Please check this field.');
              });
              const first = controls.find((field) => field.getAttribute('aria-invalid') === 'true');
              if (first) first.focus();
            }
            throw new Error('Enquiry rejected');
          }
          lastSuccess = Date.now();
          const success = form.parentElement.querySelector('[data-success]');
          form.hidden = true;
          success.hidden = false;
          success.focus();
        } catch (error) {
          sendError.hidden = false;
        } finally {
          clearTimeout(timeout);
          pending = false;
          button.disabled = false;
          button.textContent = label;
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
